import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { View, StyleSheet } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';
import { get } from 'lodash';

import PantryDetails from '../components/pantry/PantryDetails';
import PantrySpinner from '../components/pantry/PantrySpinner';
import Colors from '../constants/Colors';
import Languages from '../constants/Languages';
import * as Actions from '../store/Actions';
import { getToken } from '../utils/token';

class PantryScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    pantry: PropTypes.objectOf(PropTypes.any).isRequired,
    route: PropTypes.objectOf(PropTypes.any),
    navigation: PropTypes.objectOf(PropTypes.any),
  };

  constructor(props) {
    super();
    const { registration, actions, route } = props;
    const { language } = registration;
    const { params } = route;

    const locale = language?.name || 'en';
    const translation = Languages.translations[locale];

    this.state = {
      organizationId: params.id,
      locale,
      translation,
      updatedAt: 0,
    };
  }

  spinnerTimer = null;

  componentDidMount = async () => {
    const { actions, route } = this.props;
    const { params } = route;
    const token = await getToken();
    const isLoggedIn = Boolean(token);

    if (params.id) {
      actions.getVisits();
      actions.showSinglePantry(params.id, isLoggedIn);
    }

    actions.getTefapConfig();
  };

  componentDidUpdate = async (newProps) => {
    const { registration } = newProps;
    // check if the locale has changed
    const { language } = registration;
    if (language?.name && language.name !== this.state.locale) {
      const locale = language.name;
      const translation = Languages.translations[locale];
      this.setState({
        locale,
        translation,
      });
    }
  };

  componentWillUnmount() {
    if (this.spinnerTimer) {
      clearTimeout(this.spinnerTimer);
    }
  }

  goBack = () => {
    const { navigation, actions } = this.props;
    // get the number of routes out of navigation state
    actions.clearSinglePantry();
    const state = navigation.getState();
    if (state.routes && state.routes.length > 1) {
      // more than 1, we have a stack and can go back
      navigation.goBack();
    } else {
      navigation.navigate('a', { screen: 'pantries' });
    }
  };

  navigateToProfile = () => {
    const { actions, navigation } = this.props;
    actions.closeMustVerify();
    actions.getCurrentUser(() => {
      navigation.navigate('a', {
        screen: 'profile',
        params: { screen: 'info' },
      });
    });
  };

  render() {
    const { translation, locale } = this.state;
    const { actions, registration, pantry, navigation } = this.props;
    const { pantry: pantryDetails } = pantry;

    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => (
          <View
            key={this.state.organizationId}
            style={[
              styles.view,
              {
                paddingTop: insets.top,
                paddingBottom: insets.bottom,
                zIndex: 1,
              },
            ]}
          >
            {!pantryDetails.id ? (
              <PantrySpinner translation={translation} showHeader={false} />
            ) : (
              <View style={styles.pantryContainer}>
                <PantryDetails
                  pantry={pantry}
                  registration={registration}
                  translation={translation}
                  locale={locale}
                  actions={actions}
                  navigation={navigation}
                  navigateToProfile={this.navigateToProfile}
                  goBack={this.goBack}
                  organizationId={parseInt(this.state.organizationId, 10)}
                />
              </View>
            )}
          </View>
        )}
      </SafeAreaInsetsContext.Consumer>
    );
  }
}

PantryScreen.navigationOptions = {
  header: null,
};

// had to play with margin bottom to get map to show ok
const styles = StyleSheet.create({
  pantryContainer: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  view: {
    color: Colors.primaryColor,
    backgroundColor: Colors.white,
    flex: 1,
  },
  scene: {
    flex: 1,
  },
  tabBarIndicator: {
    backgroundColor: Colors.mediumBlue,
    color: Colors.mediumGray,
  },
  tabBar: {
    backgroundColor: Colors.white,
  },
  modal: {
    margin: 0,
  },
  spinnerContainer: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

function mapStateToProps(state) {
  return {
    registration: state.registration,
    pantry: state.pantry,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PantryScreen);
